import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const MarketCapVolumeChart = defineAsyncComponent(() => import('@/js/global-charts/MarketCapVolumeChart.vue'));
const DominanceChart = defineAsyncComponent(() => import('@/js/global-charts/DominanceChart.vue'));
const GasPriceStatChart = defineAsyncComponent(() => import('@/js/global-charts/GasPriceStatChart.vue'));
const ProviderPicker = defineAsyncComponent(() => import('@/js/comparisons/ProviderPicker.vue'));
const BaseTippy = defineAsyncComponent(() => import('@/js/components/Tippy/BaseTippy.vue'));

app.component('ProviderPicker', ProviderPicker);
app.component('MarketCapVolumeChart', MarketCapVolumeChart);
app.component('DominanceChart', DominanceChart);
app.component('GasPriceStatChart', GasPriceStatChart);
app.component('BaseTippy', BaseTippy);

mountApp();
